import { render } from "./ChooseForm.vue?vue&type=template&id=cd9036de&scoped=true&ts=true"
import script from "./ChooseForm.vue?vue&type=script&lang=ts"
export * from "./ChooseForm.vue?vue&type=script&lang=ts"

import "./ChooseForm.vue?vue&type=style&index=0&id=cd9036de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd9036de"]])

export default __exports__